import { add, scale } from './math'
import { getTrackSample } from './track'
import type { Track, Vec2 } from './types'

const STARTING_GRID_SAMPLE_SPACING = 4
const STARTING_GRID_LATERAL_OFFSET = 2.3
const STARTING_GRID_HEADING_LOOKAHEAD = 12

export interface StartingGridPose {
  position: Vec2
  heading: number
  sampleIndex: number
}

/** Returns the canonical spawn pose for a frozen starting-grid index. */
export function getStartingGridPose(track: Track, index: number): StartingGridPose {
  const sample = getTrackSample(track, -index * STARTING_GRID_SAMPLE_SPACING)
  const start = getTrackSample(track, 0)
  const lookahead = getTrackSample(track, STARTING_GRID_HEADING_LOOKAHEAD)
  const lateral = index === 0 ? 0 : (index % 2 === 0 ? 1 : -1) * STARTING_GRID_LATERAL_OFFSET
  return {
    position: add(sample.position, scale(sample.normal, lateral)),
    heading: Math.atan2(lookahead.position.x - start.position.x, lookahead.position.y - start.position.y),
    sampleIndex: sample.index,
  }
}
